module.exports = __webpack_public_path__ + "static/media/_MIC2501.image.2913a621.png";